export function getAbsoluteUrl(relativeUrl: string): string {
    return `${window.location.origin}/${trimSlash(relativeUrl)}${window.location.search}${window.location.hash}`;
}

export function trimSlash(value: string): string {
    return value.replace(/^\/+|\/+$/g, '');
}